<template>

  <div class="main_wrapper ion-padding">
    
    <div class="subscription" v-if="isLocumateAndSpecialRole">
      <div class="input_label">Job Ad Complete</div>
      <div class="button-group special-role">
        <el-button
        class="submit"
        data-testid="directions-55"
        type="primary"
        :disabled="loading"
        @click="submitJobPost('publish')"
            >
        Publish
            </el-button>
            <el-button
        class="submit secondary"
        data-testid="directions-55"
        type="primary"
        :disabled="loading"
        @click="submitJobPost('draft')"
            >
        Save as draft
            </el-button>
      </div>
    </div>
    <div class="subscription" v-else>
      <div class="input_label">Job Ad Fee</div>
      <div v-if="subscription">
        <div class="usage-notification available" v-if="freeJobPosts !== 0">
          <!-- <p>
            You have <strong>{{ freeJobPosts }}</strong> free job ads remaining within your subscription.
          </p> -->
          <SubscriptionBar
              :remainingSubscriptions="freeJobPosts"
              :totalSubscriptions="totalNumberOfFreeJobListings"
              text="Free job ads remaining"
          />
        </div>
        <div class="usage-notification unavailable" v-if="freeJobPosts === 0">
          <p v-if="usedFreeJobListings === 0">
            You have used all your available free jobs ads. you will be charged
          </p>
          <p>
            Job Ad Fee of
            <strong>{{ Amount(jobPostingPrice) }}</strong> <span  v-if="isAus">(Including GST)</span>
            for this job post will be charged in the next invoice.
          </p>
          <div v-html="discountAndTaxInfosHtml"></div>
        </div>
      </div>
      <div v-else>
        <div class="usage-notification unavailable">
          <p>
            You will be charged a Job Ad Fee of
            <strong>{{ Amount(justJobPostingPrice) }}</strong> <span v-if="isAus" >(Excluding GST)</span>.
            Click "Publish" to proceed to the payment screen
          </p>
          <div v-html="discountAndTaxInfosHtml"></div>
        </div>
      </div>

      <div class="coupon-code mb-3" v-if="freeJobPosts === 0">
        <CouponCodeComponent
          @updateDiscount="updateJobPostingPrice"
          @clearCouponCode="clearCouponCode"
        />
      </div>

      <div class="button-group">
        <template v-if="freeJobPosts === 0">
          <el-button
            class="submit"
            type="primary"
            data-testid="directions-56"
            @click="payToPublish()"
          >
            Publish
          </el-button>
        </template>
        <template v-else>
          <el-button
            class="submit"
            data-testid="directions-55"
            type="primary"
            :disabled="loading"
            @click="submitJobPost('publish')"
          >
            Publish
          </el-button>
        </template>
        <el-button
          class="submit secondary"
          data-testid="directions-55"
          type="primary"
          :disabled="loading"
          @click="submitJobPost('draft')"
        >
          Save as draft
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { ref,computed } from "vue";

import { addIcons } from "ionicons";
import { arrowBackOutline } from "ionicons/icons";
addIcons({
  "arrow-back-outline": arrowBackOutline,
});
// import {
//     IonToolbar,
//     IonButton,
//     IonButtons,
//     IonIcon,
// } from '@ionic/vue';

import { useRouter } from "vue-router";
import { ElMessage } from "@/components/Vendor/Element";
import { useStore } from "vuex";
// import StripePaymentForm from "@/components/MarketplaceJobs";
import CouponCodeComponent from "../../Components/CouponCodeComponent.vue";
import { isAustraliaRegion } from '@/helpers/region/regionHelper';
import SubscriptionBar from "@/components/Subscription/SubscriptionBar.vue";

export default {
  components: {
    // IonToolbar,
    // IonButton,
    // IonButtons,
    // IonIcon,
    CouponCodeComponent,
    SubscriptionBar,
  },
  directives: {},
  setup() {
    const $router = useRouter();
    const $store = useStore();
    const userData = $store.getters.GET_USER_DATA;
    const jobListingCreatePageData = $store.getters.getJobListingCreatePageData;
    const platformRoleId = jobListingCreatePageData.platform_role_id ? jobListingCreatePageData.platform_role_id : null;
    const brandName = process.env.VUE_APP_BRAND;
    console.log("🚀 ~ setup ~ userData:", userData);
    const freeJobPosts =
      userData.jobListingSubscriptionDetails.remainingFreeJobListings;
    console.log("🚀 ~ setup ~ freeJobPosts:", freeJobPosts);
    const jobPostingPrice = ref(0);
    const isAus = isAustraliaRegion();

    const originalJobPostingPrice = ref(0);
    const justJobPostingPrice = ref(0);
    const discountAndTaxInfosHtml = ref("");
    const getJobPostPriceInfos = $store.dispatch("GET_JOB_POST_PRICE_INFOS");
    getJobPostPriceInfos
      .then((data) => {
        jobPostingPrice.value = data.jobPostingPrice;
        originalJobPostingPrice.value = data.jobPostingPrice;
        justJobPostingPrice.value = data.justJobPostingPrice;
        discountAndTaxInfosHtml.value = data.jobpostDiscountAndTaxInfoHtml;
      })
      .catch((error) => {
        console.error("Error fetching job post price info:", error);
      });

    const usedFreeJobListings =
      userData.jobListingSubscriptionDetails.usedFreeJobListings;
    const totalNumberOfFreeJobListings =
      userData.jobListingSubscriptionDetails.totalNumberOfFreeJobListings;
    console.log("🚀 ~ setup ~ jobPostingPrice:", jobPostingPrice);
    const subscription = ref(
      userData.calculatedSubscriptions &&
        userData.calculatedSubscriptions.subscription
        ? userData.calculatedSubscriptions.subscription
        : 0
    );
    const loading = ref(false);

    const updateJobPostingPrice = (response) => {
      jobPostingPrice.value = response.newJobPostingPrice;
      discountAndTaxInfosHtml.value = response.discountAndTaxInfosHtml;
      // if (discountInfo.type === "percent") {
      //   jobPostingPrice.value =
      //     jobPostingPrice.value -
      //     (discountInfo.percent / 100) * jobPostingPrice.value;
      // }

      // if (discountInfo.type === "amount") {
      //   jobPostingPrice.value =
      //     jobPostingPrice.value - discountInfo.converted_amount;
      // }
    };

    const clearCouponCode = (isCleared) => {
      if (isCleared) {
        jobPostingPrice.value = originalJobPostingPrice.value;
        getJobPostPriceInfos
          .then((data) => {
            jobPostingPrice.value = data.jobPostingPrice;
            originalJobPostingPrice.value = data.jobPostingPrice;
            justJobPostingPrice.value = data.justJobPostingPrice;
            discountAndTaxInfosHtml.value = data.jobpostDiscountAndTaxInfoHtml;
          })
          .catch((error) => {
            console.error("Error fetching job post price info:", error);
          });
      }
    };

    const goBack = () => {
      $router.push({
        name: "job_question_listing",
      });
    };

    const payToPublish = () => {
      $router.push({
        name: "job_lisiting_payment",
      });
    };

    const submitJobPost = (actionType) => {
      (async () => {
        try {
          loading.value = true;
          const response = await $store.dispatch("SAVE_JOB_POST", actionType);
          $store.dispatch("clearJobListingCreatePageData");
          if (response.success) {
            if (actionType == "draft") {
              ElMessage({
                type: "success",
                message: "Job has been saved as draft successfully",
              });
            } else {
              ElMessage({
                type: "success",
                message: "Job has been published successfully",
              });
            }
            $store.dispatch("CLEAR_APPLIED_COUPON");
            $store.dispatch("SET_CURRENT_USER_DATA", {
              with: "settings,billingInfo,schedule,bankVerification,address,push_notifications,config.hours_before_shift_lock",
            });
            $router.push({
              name: "job_poster",
            });
          }
        } catch (error) {
          console.log(error);
        } finally {
          loading.value = false; // Re-enable the button
        }
      })();
    };

    const Amount = (amount) => {
      return Intl.NumberFormat("en-AU", {
        style: "currency",
        currency: "AUD",
      }).format(amount);
    };

    const isLocumateAndSpecialRole = computed(() => {
      return brandName === "LOCUMATE" && (platformRoleId === 3 || platformRoleId === 4);
    });

    return {
      goBack,
      submitJobPost,
      freeJobPosts,
      jobPostingPrice,
      usedFreeJobListings,
      Amount,
      subscription,
      payToPublish,
      loading,
      updateJobPostingPrice,
      clearCouponCode,
      discountAndTaxInfosHtml,
      getJobPostPriceInfos,
      originalJobPostingPrice,
      justJobPostingPrice,
      isAus,
      jobListingCreatePageData,
      brandName,
      platformRoleId,
      isLocumateAndSpecialRole,
      totalNumberOfFreeJobListings
    };
  },
};
</script>
